<div class="open-card-container" [ngClass]="[componentDetails?.settings?.class || '', 'is-' + componentDetails?.settings?.type]">
  <div class="open-card">

    <!-- Card image -->
    <div class="open-card-image" *ngIf="componentDetails?.settings?.imageUrl">
      <img [src]="componentDetails.settings.imageUrl" />
    </div>

    <!-- Card content -->
    <div class="open-card-details" [ngClass]="['text-'+(componentDetails?.settings?.align || 'left'), textPadded]">
      <div class="open-card-badges" [ngClass]="'flex-justify-'+(componentDetails?.settings?.badges?.align || 'start')" *ngIf="componentDetails?.settings?.badges?.items && componentDetails.settings.badges.items.length > 0">
        <ng-container *ngFor="let badge of componentDetails?.settings?.badges?.items">
          <open-badge [label]="badge.label" [variant]="badge.variant"></open-badge>
        </ng-container>
      </div>

      <h2 *ngIf="componentDetails?.settings?.title" [innerHtml]="componentDetails.settings.title"></h2>

      <!-- This section is used to render dynamic tags -->
      <div class="open-card-content" *ngIf="componentDetails?.settings?.content" [innerHtml]="componentDetails.settings.content"></div>

      <div class="open-card-features" *ngIf="componentDetails?.settings?.features && componentDetails.settings.features.length > 0">
        <div *ngFor="let item of componentDetails.settings.features" class="flex margin-bottom-xxsmall" [ngClass]="'flex-justify-'+(item.align || 'start')">
          <mat-icon [ngClass]="item.is_included ? '' : 'optional'">
            {{ item.is_included ? 'check_circle_fill' : 'cancel' }}
          </mat-icon>
          <span class="flex-shrink" [innerHTML]="item.text"></span>
        </div>
      </div>
      
      <div class="open-card-buttons" [ngClass]="'flex-justify-'+(componentDetails?.settings?.buttons?.align || 'left')" *ngIf="componentDetails?.settings?.buttons?.items && componentDetails.settings.buttons.items.length > 0">
        <ng-container *ngFor="let button of componentDetails.settings.buttons.items">

          <ng-container *ngIf="button.url">
            <ng-container [ngSwitch]="button.type">
              <a *ngSwitchCase="'stroked'" mat-stroked-button [color]="button.color" [href]="button.url" class="button-appearance">{{ button.text }}</a>
              <a *ngSwitchDefault mat-flat-button [color]="button.color" [href]="button.url" class="button-appearance">{{ button.text }}</a>
            </ng-container>  
          </ng-container>

          <ng-container *ngIf="button.action">
            <ng-container [ngSwitch]="button.type">
              <button *ngSwitchCase="'stroked'" mat-stroked-button  [color]="button.color">{{ button.text }}</button>
              <button *ngSwitchDefault mat-flat-button  [color]="button.color">{{ button.text }}</button>
            </ng-container>  
          </ng-container>
          
        </ng-container>
      </div>
    </div>
  </div>
</div>
